// Compass widget controller — mirrors the pergola compass UX.
// Drag the sun dot to override azimuth; drag the awning rectangle to set
// the home/awning facing direction. Tap the badge to clear manual mode.

const SUN_RADIUS = 36;        // pixels from compass center
const COMPASS_CX = 55;
const COMPASS_CY = 55;

export function bindCompass(state, app) {
  const svg = document.getElementById('awning-compass');
  if (!svg || !app) return null;

  const sunDot  = document.getElementById('awning-sun-dot');
  const sunGlow = document.getElementById('awning-sun-glow');
  const sunHit  = document.getElementById('awning-sun-hit');
  const rect    = document.getElementById('compass-awning');
  const badge   = document.getElementById('awning-compass-badge');

  let facingDeg = 270;          // default: awning opens westward toward afternoon sun

  function updateSunDot(azDeg) {
    const azRad = (azDeg * Math.PI) / 180;
    const cx = COMPASS_CX + Math.sin(azRad) * SUN_RADIUS;
    const cy = COMPASS_CY - Math.cos(azRad) * SUN_RADIUS;
    if (sunDot)  { sunDot.setAttribute('cx', cx); sunDot.setAttribute('cy', cy); }
    if (sunGlow) { sunGlow.setAttribute('cx', cx); sunGlow.setAttribute('cy', cy); }
    if (sunHit)  { sunHit.setAttribute('cx', cx);  sunHit.setAttribute('cy', cy); }
  }

  // Rect: thicker line at top edge represents the front (fabric-extension side).
  // SVG rotate is clockwise. At rotation=facingDeg the front line lines up with
  // the compass cardinal direction matching facingDeg (0=N, 90=E, 180=S, 270=W).
  function updateRectRotation() {
    if (rect) rect.setAttribute('transform', `rotate(${facingDeg}, ${COMPASS_CX}, ${COMPASS_CY})`);
  }

  function paintSunFromSim() {
    const p = app.getSunController().getLightParams();
    updateSunDot(p.azimuthDeg);
  }

  // ── Sun-dot drag → manual azimuth override ────────────────────────
  function pointerToSvg(evt) {
    const ctm = svg.getScreenCTM();
    if (!ctm) return null;
    const pt = svg.createSVGPoint();
    pt.x = evt.clientX; pt.y = evt.clientY;
    return pt.matrixTransform(ctm.inverse());
  }

  function azFromPoint(p) {
    const dx = p.x - COMPASS_CX;
    const dy = p.y - COMPASS_CY;
    const az = (Math.atan2(dx, -dy) * 180) / Math.PI;
    return ((az + 360) % 360);
  }

  let dragging = null;        // 'sun' | 'rect' | null

  function onPointerDown(target, evt) {
    if (target === 'sun' || target === 'rect') {
      dragging = target;
      document.body.style.cursor = 'grabbing';
      evt.preventDefault();
    }
  }
  function onPointerMove(evt) {
    if (!dragging) return;
    const p = pointerToSvg(evt);
    if (!p) return;
    const az = azFromPoint(p);
    if (dragging === 'sun') {
      app.setManualAzimuth(az);
      updateSunDot(az);
      if (badge) badge.style.display = '';
    } else {
      facingDeg = az;
      app.setFacingDeg(az);
      updateRectRotation();
    }
  }
  function onPointerUp() {
    dragging = null;
    document.body.style.cursor = '';
  }

  if (sunDot) sunDot.addEventListener('pointerdown', (e) => onPointerDown('sun', e));
  if (sunHit) sunHit.addEventListener('pointerdown', (e) => onPointerDown('sun', e));
  if (rect)   rect.addEventListener('pointerdown',   (e) => onPointerDown('rect', e));
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);

  if (badge) {
    badge.addEventListener('click', () => {
      app.clearManualAzimuth();
      badge.style.display = 'none';
      paintSunFromSim();
    });
  }

  // Refresh sun-dot position on a slow timer so it follows the time slider.
  // Skip refresh while user is dragging or in manual-azimuth mode.
  setInterval(() => {
    if (dragging === 'sun') return;
    if (app.getSunController().isManual()) return;
    paintSunFromSim();
  }, 200);

  paintSunFromSim();
  updateRectRotation();
  return { paintSunFromSim, setFacingDeg: (d) => { facingDeg = d; updateRectRotation(); } };
}
